import { getUrl } from 'aws-amplify/storage';

const GetVideo = async (file) => {
    try {
        const downloadResult = await getUrl({
            path: `public/${file.file}`,
        });
        const text = await downloadResult.url;
        // console.log('All files:', filteredBodies);
        return text
    } catch (error) {
        console.error('Error fetching file URLs:', error);
        return [];
    }
};

export default GetVideo;
